import { UseQueryResult } from "@tanstack/react-query";
import React from "react";

export default function QueryRenderer<T>(params: {
  query: UseQueryResult<T, unknown>;
  onLoading: () => React.ReactNode;
  onSuccess: (data: T) => React.ReactNode;
  onError: () => React.ReactNode;
}) {
  switch (params.query.status) {
    case "error":
      return <>{params.onError()}</>;
    case "loading":
      return <>{params.onLoading()}</>;
    case "success":
      return <>{params.onSuccess(params.query.data)}</>;
  }
}
